// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"ff48e093","280":"0c501ccb","382":"a24b8c92"}[chunkId] + ".chunk.css";
};